module.exports = __webpack_public_path__ + "static/media/noe_logo.672208ea.png";